import { render } from "./Detalle.vue?vue&type=template&id=57b3a625"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"

import "./Detalle.vue?vue&type=style&index=0&id=57b3a625&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__